import { useEffect, useState } from "react";
import { TbFileText, TbReceipt } from "react-icons/tb";
import { CardExtractSection } from "./CardExtractSection";
import { CardInvoicesSection } from "./CardInvoicesSection";

const TABS = [
  { id: "extrato", label: "Extrato", icon: TbFileText },
  { id: "faturas", label: "Faturas", icon: TbReceipt },
];

export const CartoesDocumentPanel = ({ cardType, cardLabel, cardLast4, onPayInvoice }) => {
  const isCredit = cardType === "credit";
  const [activeTab, setActiveTab] = useState("extrato");

  useEffect(() => {
    setActiveTab("extrato");
  }, [isCredit, cardLast4]);

  return (
    <section className="cartoes-doc-panel app-card">
      <div className="cartoes-doc-panel__head">
        <div>
          <h3 className="text-sm font-bold text-brand-dark">
            {isCredit ? "Extrato e faturas" : "Extrato"}
          </h3>
          <p className="mt-0.5 text-xs text-gray-500">
            {isCredit
              ? "Consulte lançamentos do cartão ou faturas em aberto."
              : "Lançamentos do cartão selecionado."}
          </p>
        </div>

        {isCredit && (
          <div className="cartoes-segment" role="tablist" aria-label="Consultas do cartão">
            {TABS.map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                type="button"
                role="tab"
                aria-selected={activeTab === id}
                className={`cartoes-segment__btn ${
                  activeTab === id ? "cartoes-segment__btn--active" : ""
                }`}
                onClick={() => setActiveTab(id)}
              >
                <Icon className="h-3.5 w-3.5" />
                {label}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="cartoes-doc-panel__body">
        {isCredit && activeTab === "faturas" && (
          <CardInvoicesSection embedded onPayInvoice={onPayInvoice} />
        )}

        {(activeTab === "extrato" || !isCredit) && (
          <CardExtractSection embedded cardLabel={cardLabel} cardLast4={cardLast4} />
        )}
      </div>
    </section>
  );
};
